import {useIntersectionObserver} from 'usehooks-ts'
import {useParams} from 'react-router-dom'
import {useReactiveVar} from '@apollo/client'

import {isXcEditorVar, OfficeIntegrationEnum} from '@sdox/api'
import {Loading} from '@sdox/ui'

import {useLoadIntegration} from './useLoadIntegration'

import type {XcNwBlock_BlockIntegrationType_Fragment} from '@sdox/api'

const BlockIntegrationEufe = (props: XcNwBlock_BlockIntegrationType_Fragment) => {
  const {seFolderSlug, clpSlug} = useParams()
  if (!seFolderSlug && !clpSlug) throw new Error('Programming error - no seFolderSlug/clpSlug set')

  const {isIntersecting, ref} = useIntersectionObserver({freezeOnceVisible: true, rootMargin: '100px'})
  const {loading} =  useLoadIntegration({
    block: props,
    skip: !isIntersecting && props.integrationType !== OfficeIntegrationEnum.NwConsumptionValueDisclaimer,
  })

  if (loading) return <Loading />
  if (!isIntersecting && props.integrationType !== OfficeIntegrationEnum.NwConsumptionValueDisclaimer){
    return (
      <div
        ref={ref}
        className={'w-1'}
      />
    )
  }

  return null
}

const BlockIntegrationEditor = (props: XcNwBlock_BlockIntegrationType_Fragment) => {
  return <div>Integration: [{props.integrationType} {props.defaultValue || 'default'}]</div>
}

export const BlockIntegration = (props: XcNwBlock_BlockIntegrationType_Fragment) => {
  const isEditor = useReactiveVar(isXcEditorVar)

  if (isEditor){
    return <BlockIntegrationEditor {...props} />
  }
  return <BlockIntegrationEufe {...props} />
}
